<template>
	<ModalComponent
		ref="modalRef"
		:isHeader="false"
		:isFooter="false"
		:is-background-transparent="true"
		@close="resetValue"
	>
		<div class="trade-ticket bg-grey-10 rounded-2.5xl p-5">
			<div class="flex items-center gap-2 text-xs text-white mb-5">
				<div class="grow text-2xl font-bold">Order</div>

				<div>
					<IconGoldCircle :sizeMultiplier_prop="0.75" />
				</div>
				<div class="font-bold">{{ name }}</div>
			</div>

			<div class="flex justify-between gap-2 text-xs mb-5">
				<button
					:class="`flex-1 btn text-xs W-100 ${
						direction == 'sell' ? 'c-btn-danger' : 'bg-grey-12'
					} rounded-md py-2.5`"
					@click="changeDirection('sell')"
				>
					<span class="fw-700 d-inline">SELL</span>
					<span class="fw-400 d-inline">{{ sellPriceShow }}</span>
				</button>

				<button
					:class="`flex-1 btn text-xs W-100 ${
						direction == 'buy' ? 'c-btn-success' : 'bg-grey-12'
					} rounded-md py-2.5`"
					@click="changeDirection('buy')"
				>
					<span class="fw-700 d-inline">BUY</span>
					<span class="fw-400 d-inline">{{ buyPriceShow }}</span>
				</button>
			</div>

			<!-- Order Type -->
			<div
				v-if="$store.getters.paymentMethod == 'rped'"
				class="flex items-center text-center text-xs text-white font-bold border-solid border-0 border-b border-b-theme"
			>
				<div
					:class="`${
						orderType == 'market' ? 'bg-theme' : 'bg-grey-12'
					} flex-1 rounded-tl-md cursor-pointer py-2.5`"
					@click="orderTypeFunction(1)"
				>
					MARKET
				</div>
				<div
					:class="`${
						orderType == 'limit' ? 'bg-theme' : 'bg-grey-12'
					} flex-1 rounded-tr-md cursor-pointer py-2.5`"
					@click="orderTypeFunction(2)"
				>
					LIMIT
				</div>
			</div>

			<div class="bg-grey-12 rounded-b-md text-white text-xs mb-5 p-5">
				<!-- Available Balance -->
				<div class="mb-5">
					<AvailableBalance v-if="direction == 'buy'" />
					<AvailableGoldBalance v-else :contractId="contractId_prop" />
				</div>

				<!-- Input Order -->
				<InputOrder
					ref="inputOrderRef"
					:contractId="contractId_prop"
					:direction="direction"
					:orderType="orderType"
					:totalTypeAIdr="totalTypeAIdr"
					:totalTypeAUsd="totalTypeAUsd"
					:finalAmountIdr="finalAmountIdr"
					:finalAmountUsd="finalAmountUsd"
					:limitPrice="priceGram.toString()"
					@totalGramUpdated="updateQuantityInt"
					@limitPriceUpdated="updatePriceGram"
					:preventReview.sync="preventReview"
				/>
			</div>

			<!-- Order Validity -->
			<div
				v-if="orderType == 'limit'"
				class="bg-grey-12 rounded-md text-white text-xs mb-5 p-5"
			>
				<OrderValidity
					:validity.sync="validity"
					:limitOrderDate.sync="limitOrderDate"
				/>
			</div>

			<!-- RoG -->
			<div
				v-if="
					$store.getters.paymentMethod == 'rped' &&
					isEventRogActive &&
					direction == 'buy'
				"
				class="bg-grey-12 rounded-md text-white text-xs mb-5 p-5"
			>
				<InstantROG :orderDetailsIdr="tradeTicketDataIdr" />
			</div>

			<!-- Order Details -->
			<div class="mb-5">
				<OrderDetails
					:orderDetails="
						currency == 'usd' ? tradeTicketDataUsd : tradeTicketDataIdr
					"
					:direction="direction"
				/>
			</div>

			<!-- Estimasi Profit -->
			<div
				v-if="direction == 'sell'"
				class="flex justify-between bg-grey-12 rounded-md text-white text-xs mb-5 p-5"
			>
				<div>Estimated Profit</div>
				<div
					:class="`${
						estimasiProfitShown.includes('-')
							? 'text-danger'
							: estimasiProfitShown.includes('+')
							? 'text-success'
							: 'text-white'
					}`"
				>
					{{ estimasiProfitShown }}
				</div>
			</div>

			<!-- Notes Gopay Limit -->
			<div
				v-if="$store.getters.paymentMethod == 'gopay' && direction == 'sell'"
				class="text-grey text-2xs mb-2"
			>
				Gold sale proceeds will be credited to your GoPay. If the GoPay limit is
				reached, the funds will be transferred to your withdrawal bank account.
			</div>

			<!-- Notes Partial Filled -->
			<div class="text-grey text-2xs mb-5">
				Orders may be partially filled.
				<span
					class="text-theme cursor-pointer"
					@click="$refs.partialFilledExplainedRef.openPartialFilledExplained()"
				>
					Learn more
				</span>
			</div>

			<!-- Buttons -->
			<div class="">
				<div
					v-if="this.$store.state.marketInquiryStatus == 'loading'"
					class="col-12 text-center"
				>
					<Loader size_prop="3em"> </Loader>
				</div>
				<div v-else>
					<button
						class="ga-open-depth w-full btn bg-grey-12 text-theme text-xs font-bold mb-2"
						@click="openDepth()"
					>
						DEPTH
					</button>

					<div class="flex justity-between flex--same-width gap-2">
						<div>
							<button
								id="buttonCloseTradeTicket"
								type="button"
								class="ga-close-trade-ticket btn bg-grey-12 text-red text-xs font-bold w-full"
								@click="closeTradeTicket()"
							>
								CLOSE
							</button>
						</div>

						<div>
							<button
								v-if="
									this.$store.getters.getAccountLevel == 'client' &&
									this.$store.getters.getBrokerName == 'metalgo' &&
									product_is_active_prop == 'active' &&
									!isReviewOrderButtonDisabled
								"
								class="ga-open-review-order btn c-btn-theme text-xs w-full"
								@click="showReviewOrder()"
							>
								{{
									$store.getters.paymentMethod == "rped"
										? "REVIEW ORDER"
										: "SUBMIT ORDER"
								}}
							</button>

							<div v-else class="">
								<button class="btn c-btn-theme text-xs w-full" disabled>
									REVIEW ORDER
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="false">
				<div class="bg-grey-12 rounded-md text-white text-xs mb-5 p-5 mt-5">
					<div class="balance-section mb-4">
						<div
							class="flex justify-between items-center cursor-hover-pointer mb-2"
							@click="expandBalance()"
						>
							<div class="font-semibold">Estimated Order Details</div>
							<div class="">
								<IconArrow :direction_prop="arrowDirectionBalance" />
							</div>
						</div>

						<div class="balance-content">
							<!-- Market -->
							<div
								v-if="orderType == 'market'"
								class="tab-pane active"
								id="link-market"
								aria-expanded="true"
							>
								<div class="rounded text-left value-field mb-2">
									<template v-if="product_is_active_prop == 'active'">
										<div class="flex justify-between items-center mb-4">
											<div class="text-left">Kuantitas</div>
											<div class="float-right c-input-field">
												<button
													class="button button-counter decrease"
													@click="decreaseQuantityInt()"
												>
													-
												</button>
												<input
													ref="quantityMarket"
													class="c-input number-font"
													type="number"
													name=""
													v-model.number="quantityIntInInput"
												/>
												<button
													class="button-counter increase"
													@click="increaseQuantityInt()"
												>
													+
												</button>
											</div>
										</div>

										<div v-if="contractConfigs.hasQuantityDecimal" class="mb-4">
											<span class="text-left" style="color: transparent"
												>.</span
											>
											<div class="float-right c-input-field">
												<button
													class="button button-counter decrease"
													@click="decreaseQuantityDecimal()"
												>
													-
												</button>
												<span>
													<input
														class="c-input number-font"
														type="number"
														name=""
														v-model.number="quantityDecimalInInput"
													/>
												</span>
												<button
													class="button-counter increase"
													@click="increaseQuantityDecimal()"
												>
													+
												</button>
											</div>
										</div>

										<div v-if="contractConfigs.hasQuantityDecimal">
											<span class="text-left">Total Quantity</span>
											<div class="text-right float-right text-white">
												{{ quantityShown }}
											</div>
										</div>
									</template>
									<template v-else>
										<div class="mb-4">
											<span class="text-left">Quantity</span>
											<div class="float-right c-input-field">
												<button class="button button-counter decrease">
													-
												</button>
												<input
													class="c-input number-font"
													type="number"
													name=""
													value="0"
													disabled
												/>
												<button class="button-counter increase">+</button>
											</div>
										</div>
									</template>

									<div class="mb-3">
										<span class="text-left">Total Gram</span>
										<div class="text-right float-right text-white">
											{{ gramShown }}
										</div>
									</div>

									<hr
										class="border border-transparent border-grey-1 mt-0 mb-3 mx--5"
									/>

									<div class="mb-3">
										<div class="font-medium mb-1.5">
											<span class="mr-1">Rincian Order</span>
											<TooltipRincianOrder :direction="direction" />
										</div>

										<div class="mb-1.5">
											<span class="text-left position-relative">
												Contract Value
											</span>
											<div
												class="text-right float-right text-white number-font"
											>
												{{ currencySymbol }} {{ valueShown }}
											</div>
										</div>

										<div class="mb-1.5">
											<span class="text-left position-relative" title="test">
												Fee
											</span>
											<div
												class="text-right float-right text-white number-font"
											>
												{{ minusSign }} {{ currencySymbol }} {{ feeShown }}
											</div>
										</div>

										<div class="mb-1.5">
											<span class="text-left position-relative"> Tax </span>
											<div
												class="text-right float-right text-white number-font"
											>
												{{ minusSign }} {{ currencySymbol }} {{ taxShown }}
											</div>
										</div>

										<div class="mb-3">
											<span class="text-left position-relative">
												{{
													direction == "sell"
														? "Total Sell Order"
														: "Total Buy Order"
												}}
											</span>

											<div
												class="text-right float-right text-white number-font"
											>
												{{ currencySymbol }} {{ totalTypeAShown }}
											</div>
										</div>

										<hr
											v-if="$store.getters.paymentMethod == 'gopay'"
											class="border border-transparent border-grey-1 m-0 mb-3"
										/>

										<div
											v-if="$store.getters.paymentMethod == 'gopay'"
											class="mb-3"
										>
											<span class="text-left position-relative">
												Biaya Admin <span class=""></span>
											</span>

											<div
												class="text-right float-right text-white number-font"
											>
												{{ minusSign }} {{ currencySymbol }} {{ adminFeeShown }}
											</div>
										</div>

										<!-- <hr v-if="$store.getters.paymentMethod == 'gopay'"
											class="border border-transparent border-grey-1 m-0 mb-3"> -->

										<!-- <div class="font-semibold">
											<div class="flex justify-between items-center">
												<div v-if="direction == 'sell'" class="text-left">
													Total Sell Order
												</div>
												<div v-else-if="direction == 'buy'" class="text-left">
													Total Buy Order
												</div>

												<div class="text-right number-font">
													{{ currencySymbol }} {{ totalTypeAShown }}
												</div>
											</div>
										</div> -->

										<hr
											class="border border-transparent border-grey-1 mt-0 mb-3"
										/>

										<div v-if="direction == 'sell'" class="mb-1.5">
											<span class="text-left position-relative">
												Storage Fee
											</span>
											<div
												class="text-right float-right text-white number-font"
											>
												{{ currencySymbol }} {{ storageFeeShown }}
											</div>
										</div>

										<div v-if="direction == 'buy'" class="mb-1.5">
											<span class="text-left position-relative">
												FX Buffer
											</span>
											<div
												class="text-right float-right text-white number-font"
											>
												Rp {{ fxBufferShown }}
											</div>
										</div>

										<div class="font-semibold text-gold">
											<div class="flex justify-between items-center">
												<div v-if="direction == 'sell'" class="text-left">
													Estimasi Diterima
												</div>
												<div v-else-if="direction == 'buy'" class="text-left">
													Total Bayar
												</div>

												<div
													v-if="currency == 'idr'"
													class="text-right float-right number-font"
												>
													Rp {{ finalAmountIdrShown }}
												</div>
												<div v-else class="text-right float-right number-font">
													$ {{ finalAmountUsdShown }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Limit -->
							<div
								v-if="orderType == 'limit'"
								class="tab-pane"
								id="link-limit"
								aria-expanded="false"
							>
								<div class="rounded text-left value-field mb-2">
									<div class="flex justify-between items-center mb-2">
										<div class="text-left">Validity</div>

										<div class="c-select-box rounded">
											<span>
												{{
													validity == "GTC" ? "Until Cancel" : "For Date / Time"
												}}
											</span>
											<select class="c-select" v-model="validity">
												<option value="GTC">Until Cancel</option>
												<option value="GTD">For Date / Time</option>
											</select>
										</div>
									</div>

									<div
										v-if="validity == 'GTD'"
										class="flex justify-between items-center mb-2"
									>
										<div class="text-left">Expire Date</div>
										<input
											type="datetime-local"
											name=""
											class="rounded c-input c-date-picker"
											v-model="limitOrderDate"
											:min="minExpiryDateInInput"
											onkeydown="return false"
										/>
									</div>

									<template v-if="product_is_active_prop == 'active'">
										<div class="flex justify-between items-center mb-2">
											<div class="text-left">Quantity</div>
											<div class="c-input-field">
												<button
													class="button button-counter decrease"
													@click="decreaseQuantityInt()"
												>
													-
												</button>
												<input
													ref="quantityMarket"
													class="c-input number-font"
													type="number"
													name=""
													v-model.number="quantityIntInInput"
												/>
												<button
													class="button-counter increase"
													@click="increaseQuantityInt()"
												>
													+
												</button>
											</div>
										</div>

										<div
											v-if="contractConfigs.hasQuantityDecimal"
											class="flex justify-between items-center mb-2"
										>
											<div class="text-left" style="color: transparent">-</div>
											<div class="c-input-field">
												<button
													class="button button-counter decrease"
													@click="decreaseQuantityDecimal()"
												>
													-
												</button>
												<input
													ref="quantityDecimalMarket"
													class="c-input number-font"
													type="number"
													name=""
													v-model.number="quantityDecimalInInput"
												/>
												<button
													class="button-counter increase"
													@click="increaseQuantityDecimal()"
												>
													+
												</button>
											</div>
										</div>

										<div v-if="contractConfigs.hasQuantityDecimal" class="mb-4">
											<span class="text-left">Total Quantity</span>
											<div class="text-right float-right text-white">
												{{ quantityShown }}
											</div>
										</div>

										<div class="flex justify-between items-center mb-2">
											<div class="text-left">Price Gram</div>
											<div class="c-input-field">
												<button
													class="button button-counter decrease"
													@click="decreasePriceGram()"
												>
													-
												</button>
												<input
													class="c-input number-font"
													type="text"
													name=""
													v-model.number="priceGramInInput"
												/>
												<button
													class="button-counter increase"
													@click="increasePriceGram()"
												>
													+
												</button>
											</div>
										</div>
									</template>

									<template v-else>
										<div class="mb-4">
											<span class="text-left">Quantity</span>
											<div class="float-right c-input-field">
												<button class="button button-counter decrease">
													-
												</button>
												<input
													class="c-input number-font"
													type="number"
													name=""
													value="0"
													disabled
												/>
												<button class="button-counter increase">+</button>
											</div>
										</div>

										<div class="mb-4">
											<span class="text-left">Price Gram</span>
											<div class="float-right c-input-field">
												<button class="button button-counter decrease">
													-
												</button>
												<input
													class="c-input number-font"
													type="number"
													name=""
													value="0"
													disabled
												/>
												<button class="button-counter increase">+</button>
											</div>
										</div>
									</template>

									<div class="mb-1.5">
										<span class="text-left">Total Gram</span>
										<div class="text-right float-right text-white">
											{{ gramShown }}
										</div>
									</div>

									<div class="mb-3">
										<span class="text-left position-relative">
											<span class="mr-1"> Contract Price </span>
											<Tooltip
												text_prop="Harga fisik emas per satuan berat kontrak"
												iconHeight_prop="0.75rem"
												iconWidth_prop="0.75rem"
												:iconColor_prop="colorGrey8"
											/>
										</span>
										<div class="text-right float-right text-white number-font">
											{{ currencySymbol }} {{ contractPriceLimitShown }}
										</div>
									</div>

									<hr
										class="border border-transparent border-grey-1 mt-0 mb-3 mx--5"
									/>

									<div class="">
										<div class="font-medium mb-1.5">
											<span class="mr-1">Rincian Order</span>
											<TooltipRincianOrder :direction="direction" />
										</div>

										<div class="mb-1.5">
											<span class="text-left position-relative">
												Contract Value
											</span>
											<div
												class="text-right float-right text-white number-font"
											>
												{{ currencySymbol }} {{ valueShown }}
											</div>
										</div>

										<div class="mb-1.5">
											<span class="text-left position-relative"> Fee </span>
											<div
												class="text-right float-right text-white number-font"
											>
												{{ minusSign }} {{ currencySymbol }} {{ feeShown }}
											</div>
										</div>

										<div class="mb-1.5">
											<span class="text-left position-relative"> Tax </span>
											<div
												class="text-right float-right text-white number-font"
											>
												{{ minusSign }} {{ currencySymbol }} {{ taxShown }}
											</div>
										</div>

										<div class="text-xs font-semibold">
											<div class="flex justify-between items-center mb-3">
												<span
													v-if="direction == 'sell'"
													class="text-left position-relative"
												>
													Total Sell Order
												</span>
												<span v-else class="text-left position-relative">
													Total Buy Order
												</span>

												<div class="text-right number-font">
													{{ currencySymbol }} {{ totalTypeAShown }}
												</div>
											</div>
										</div>

										<hr
											class="border border-transparent border-grey-1 mt-0 mb-3"
										/>

										<div v-if="direction == 'sell'" class="mb-1.5">
											<span class="text-left position-relative">
												Est. Storage Fee
											</span>
											<div
												class="text-right float-right text-white number-font"
											>
												{{ currencySymbol }} {{ storageFeeShown }}
											</div>
										</div>

										<div v-if="direction == 'buy'" class="mb-1.5">
											<span class="text-left position-relative">
												FX Buffer
											</span>
											<div
												class="text-right float-right text-white number-font"
											>
												Rp {{ fxBufferShown }}
											</div>
										</div>

										<div class="text-xs font-semibold text-gold">
											<div class="flex justify-between items-center mb-1.5">
												<span
													v-if="direction == 'sell'"
													class="text-left position-relative"
												>
													Estimate Diterima
												</span>
												<span v-else class="text-left position-relative">
													Total Bayar
												</span>

												<div
													v-if="currency == 'idr'"
													class="text-right float-right number-font"
												>
													Rp {{ finalAmountIdrShown }}
												</div>
												<div v-else class="text-right float-right number-font">
													$ {{ finalAmountUsdShown }}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div
									v-if="priceGram15PercentAway"
									:class="`row alert alert-danger ${
										$store.getters.getContractConfigs(contractId_prop)
											.contractType != 'kau'
											? 'bg-gold'
											: ''
									} mx-0 px-2 py-2 mb-3`"
								>
									<div class="col-auto fs-24-c">&#9888;</div>
									<div class="col pl-2">
										The price of this order is
										{{ Decimal.mul(minMaxLimitPrice, 100).toNumber() }}% away
										from current market price.
									</div>
								</div>
							</div>

							<div
								v-if="direction == 'sell'"
								class="bg-grey-1 rounded mx-2 p-3"
							>
								<span class="text-left position-relative">
									Estimasi Profit
								</span>
								<div
									class="text-right float-right number-font"
									:class="`${
										estimasiProfitShown.includes('-')
											? 'text-danger'
											: estimasiProfitShown.includes('+')
											? 'text-success'
											: 'text-white'
									}`"
								>
									{{ estimasiProfitShown }}
								</div>
							</div>
						</div>
					</div>

					<div class="flex justify-between text-gold">
						<div>Total Payment</div>
						<div>Rp0.00</div>
					</div>
				</div>

				<div class="bg-grey-12 rounded-b-md text-white text-xs mb-5 p-5 mt-5">
					<Cashback
						v-if="
							$store.getters.paymentMethod == 'rped' &&
							isEventRogActive &&
							direction == 'buy'
						"
						class="mb-4 mx-5"
						:contractValue="currency == 'idr' ? this.valueIdr : this.valueUsd"
					/>
				</div>

				<div
					v-if="$store.getters.paymentMethod == 'gopay' && direction == 'sell'"
					class="flex gap-3 bg-white-2 py-2 px-4 mb-3"
				>
					<div>
						<IconInfo2 height_prop="1.25rem" width_prop="1.25rem" />
					</div>

					<div class="text-xs text-black">
						Proceeds from gold sales will be credited to your GoPay. If your
						GoPay reaches its limit, the funds will be transferred to your
						withdrawal account.
					</div>
				</div>

				<div class="flex gap-3 bg-white-2 py-2 px-4 mb-5">
					<div>
						<IconInfo2 height_prop="1.25rem" width_prop="1.25rem" />
					</div>

					<div class="text-xs text-black">
						Orders may be subject to partial fill (partial execution).
						<span
							class="cursor-pointer text-theme"
							@click="
								$refs.partialFilledExplainedRef.openPartialFilledExplained()
							"
							>Learn more</span
						>
					</div>
				</div>

				<!-- <button class="btn" @click="openAlert()">HAHAHAAH</button> -->

				<div
					v-if="isContractStatusDisabled && isOpen"
					class="close-market"
					@click="exitCloseMarket()"
				>
					<h4 class="close-market-font rounded">
						Pre Order Trading Contract <br />
						Please contact your Brokerage firm for this transaction
						<span class="close-market-exit" @click="exitCloseMarket()">x</span>
					</h4>
				</div>
			</div>

			<DepthModal
				ref="depthRef"
				@closeDepth="closeDepth()"
				:contractId_prop="contractId_prop"
			></DepthModal>

			<ReviewOrder
				ref="reviewOrderRef"
				@submit="confirmSubmit()"
				@submitGopay="openGopayPaymentPage()"
				:reviewOrderData_prop="reviewOrderData"
			>
			</ReviewOrder>

			<GopayPaymentPage
				ref="gopayPaymentPageRef"
				@goToTradeTicket="closeReviewOrder()"
			/>
		</div>

		<PartialFilledExplained ref="partialFilledExplainedRef" />
	</ModalComponent>
</template>

<script>
	/*eslint-env jquery*/
	/* eslint-disable */
	import axios from "@/api/axios.js"
	import PerfectScrollbar from "perfect-scrollbar"
	import Swal from "sweetalert2"
	import { Decimal } from "decimal.js"
	import Alert from "./alert-component/AlertComponent"

	import { EVENT_KEYS } from "../internal/events"

	import midtransMixin from "../composable/midtransMixin"

	import TradingFormula, { currencyFormat, getPnl } from "@bei/trading-formula"
	// import TradingFormula from 'trading-formula-sdk'

	import Utils from "@/utils/index.js"

	// import Alert from '@/components/Alert.vue'
	// import store from '@/store'
	// import DepthOrder from '@/components/DepthOrder.vue'
	import ReviewOrder from "@/components/ReviewOrder.vue"
	import DepthModal from "@/components/tradeticket/DepthModal.vue"
	// import OrderTradeTicket from '@/components/OrderTradeTicket.vue'
	import Loader from "@/components/Loader.vue"
	// import BuyButton from '@/components/BuyButton.vue'
	import LogoAbx from "@/components/svg/logo-abx.vue"

	import Tooltip from "@/components/Tooltip.vue"
	import IconArrow from "@/components/icons/IconArrow.vue"
	import ModalComponent from "./ModalComponent.vue"
	import Cashback from "./Cashback.vue"
	import IconInfo2 from "./icons/IconInfo2.vue"
	import PartialFilledExplained from "./PartialFilledExplained.vue"
	import GopayPaymentPage from "./GopayPaymentPage.vue"
	import TooltipRincianOrder from "./tradeticket/TooltipRincianOrder.vue"
	import IconSwapVerticalCircle from "./icons/IconSwapVerticalCircle.vue"
	import IconGoldCircle from "./icons/IconGoldCircle.vue"
	import IconEyeClose from "@/components/icons/IconEyeClose.vue"
	import IconEyeOpen from "@/components/icons/IconEyeOpen.vue"
	import IconRefresh from "@/components/icons/IconRefresh.vue"
	import InstantROG from "./tradeticket/InstantROG.vue"
	import OrderDetails from "./tradeticket/OrderDetails.vue"
	import AvailableBalance from "./tradeticket/AvailableBalance.vue"
	import AvailableGoldBalance from "./tradeticket/AvailableGoldBalance.vue"
	import InputOrder from "./tradeticket/input-order/InputOrder.vue"
	import OrderValidity from "./tradeticket/OrderValidity.vue"

	export default {
		name: "TradeTicket",

		mixins: [midtransMixin],

		components: {
			Alert,
			// DepthOrder,
			ReviewOrder,
			DepthModal,
			// OrderTradeTicket,
			Loader,
			// BuyButton,
			LogoAbx,

			Tooltip,
			IconArrow,
			ModalComponent,
			Cashback,
			IconInfo2,
			PartialFilledExplained,
			GopayPaymentPage,
			TooltipRincianOrder,
			IconSwapVerticalCircle,
			IconGoldCircle,
			IconEyeClose,
			IconEyeOpen,
			IconRefresh,
			InstantROG,
			OrderDetails,
			AvailableBalance,
			AvailableGoldBalance,
			InputOrder,
			OrderValidity,
		},

		props: {
			contractId_prop: {
				type: String,
				default: "0",
			},
			ticker_prop: {
				type: String,
				default: "-",
			},
			name: {
				type: String,
				default: "-",
			},
			weight: {
				type: Number,
				default: 0,
			},
			weightCorection_prop: {
				type: Number,
				default: 1,
			},
			product_is_active_prop: {
				type: String,
				default: "disabled",
			},

			openSellOrders_prop: Object,

			directionDefault_prop: {
				type: [String, Number],
				default: "",
			},
		},

		data() {
			const today = new Date(Date.now())

			return {
				Decimal: Decimal,
				environment: process.env.NODE_ENV,
				publicPath: process.env.BASE_URL,
				colorGrey8: getComputedStyle(document.documentElement).getPropertyValue(
					"--color-grey8",
				),

				showTradeTicket: true,

				isDepthOpen: false,

				balanceUsdValue: 0,
				direction: "buy",
				quantityInt: 0,
				quantityDecimal: new Decimal(0),
				orderType: "market", //market or limit
				limitPrice: new Decimal(0),
				validity: "", //GTC or GTD
				idForm: "formMarket",
				reviewOrder: {},

				reviewOrderData: {},

				buyButtonActive_class: true,
				sellButtonActive_class: false,
				priceGram: new Decimal(0),
				limitOrderDate: null,
				limitOrderTime: { hour: "00:00" },
				dataSubmitMarket: {},
				isOpen: true,
				setIntervalGetDepositCooldown: "",

				// minExpiryDateInInput:`${today.getFullYear()}-${today.getMonth() + 1 < 10 ? '0' : ''}${today.getMonth() + 1}-${today.getDate() + 1 < 10 ? '0' : ''}${today.getDate() + 1}`,

				arrowDirectionBalance: "down",
				arrowDirectionHoldings: "down",

				alertType: "confirm",

				disclaimerCheck: false,

				refreshKeyQuantityIntInput: 0, // to recalculate quantityIntInInput computed

				setIntervalFetchGoldInventory: null,

				gopayRedirectUrl: null,
				snapToken: null,

				// Disable button Review Order
				preventReview: false,
			}
		},
		computed: {
			EVENT_KEYS() {
				return EVENT_KEYS
			},

			accountLevel() {
				return this.$store.getters.getAccountLevel
			},

			currency() {
				return this.$store.state.currency
			},

			isEventRogActive() {
				const eventStatus = this.$store.getters["events/getEventStatus"](
					EVENT_KEYS.rog,
				)

				return eventStatus == "ongoing" ? true : false
			},

			availableTradeBalance() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(
						this.$store.state.availableTradeBalanceUsd,
					)
				} else {
					return Utils.currencyFormat(
						this.$store.state.availableTradeBalanceIdr,
					)
				}
			},

			pricePerGramUsd() {
				const golds = this.$store.state.golds
				if (!golds || !this.contractId_prop) return 0

				const gold = golds[this.contractId_prop]
				if (!gold) return 0

				let pricePerGram
				if (this.direction == "buy") {
					pricePerGram = gold.pricePerGramBuy
				} else {
					pricePerGram = gold.pricePerGramSell
				}

				if (this.orderType == "limit") {
					pricePerGram = this.priceGram
				}

				if (pricePerGram == "-") {
					pricePerGram = 0
				}

				return pricePerGram
			},

			pricePerGramIdr() {
				const streamingRate = this.$store.getters.streamingRateByDirection(
					this.direction,
				)
				const decimalPlaces = this.$store.state.fractionDigit.idr
				const returnValue = Decimal.mul(
					this.pricePerGramUsd,
					streamingRate,
				).toFixed(decimalPlaces)

				return returnValue
			},

			rate() {
				let rate
				if (this.direction == "buy") {
					rate = this.streamingRate.streamBuy
				} else {
					rate = this.streamingRate.streamSell
				}

				return rate
			},

			tradeTicketDataUsd() {
				const quantity = new Decimal(this.quantity).toNumber()

				const param = {
					paymentMethod: this.$store.getters.paymentMethod,
					quantity: quantity,
					pricePerGramUsd: this.pricePerGramUsd,
					contractWeight: this.contractConfigs.weightInGram,
					direction: this.direction,
					orderType: this.orderType,
					currency: "usd",
					rateUsdToCurrency: this.rate || -1,
					rateCurrencyToIdr: this.rate,
				}
				const tradingData = TradingFormula.tradeTicket.tradeTicketData(param)

				return tradingData
			},

			tradeTicketDataIdr() {
				const quantity = new Decimal(this.quantity).toNumber()

				const param = {
					paymentMethod: this.$store.getters.paymentMethod,
					quantity: quantity,
					pricePerGramUsd: this.pricePerGramUsd,
					contractWeight: this.contractConfigs.weightInGram,
					direction: this.direction,
					orderType: this.orderType,
					currency: "idr",
					rateUsdToCurrency: this.rate || -1,
					rateCurrencyToIdr: this.rate,
				}
				const tradingData = TradingFormula.tradeTicket.tradeTicketData(param)

				return tradingData
			},

			hin() {
				let account = this.$store.state.account
				if (account) {
					return account.hin
				} else {
					return "-"
				}
			},

			contractConfigs() {
				return this.$store.getters.getContractConfigs(this.contractId_prop)
			},

			streamingRate() {
				return this.$store.getters.getStreamingRate
			},

			weightMultiplication() {
				let temp = this.contractConfigs
				if (temp) {
					return temp.weightMultiplication
				}
				return 1
			},

			codeName() {
				let temp = this.contractConfigs
				if (temp) {
					return temp.codeName
				}
				return ""
			},

			minMaxLimitPrice() {
				const contractConfig = this.contractConfigs
				if (contractConfig.contractType == "kau") {
					return this.$store.state.minMaxLimitPriceKAU
				}
				return this.$store.state.minMaxLimitPriceIGX
			},

			openSellOrder() {
				const temp = this.openSellOrders_prop[this.contractId_prop]
				if (temp) return temp

				return 0
			},

			minExpiryDateInInput() {
				const dateNow = new Date()

				const day =
					dateNow.getDate() < 10 ? "0" + dateNow.getDate() : dateNow.getDate()
				const month =
					dateNow.getMonth() + 1 < 10
						? "0" + (dateNow.getMonth() + 1)
						: dateNow.getMonth() + 1
				const year =
					dateNow.getFullYear() < 10
						? "0" + dateNow.getFullYear()
						: dateNow.getFullYear()
				const hours =
					dateNow.getHours() < 10
						? "0" + dateNow.getHours()
						: dateNow.getHours()
				const minutes =
					dateNow.getMinutes() < 10
						? "0" + dateNow.getMinutes()
						: dateNow.getMinutes()

				const dateTemp =
					year + "-" + month + "-" + day + " " + hours + ":" + minutes

				return dateTemp
			},

			expiryDate() {
				// let dayMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu' ,'Fri' ,'Sat']
				let monthMap = [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December",
				]
				let date = new Date(this.limitOrderDate + "T00:00:00")

				if (!this.limitOrderDate) {
					// 1 month from now
					let temp = new Date(Date.now())
					temp.setMonth(temp.getMonth() + 1)
					date = temp
				}

				return date
			},
			sellPrice() {
				const golds = this.$store.state.golds
				if (golds && this.contractId_prop) {
					let gold = golds[this.contractId_prop]

					if (!gold) return "-"

					if (gold.sell < 0 || gold.id == 0) {
						if (gold.buy < 0 || gold.id == 0) {
							return "-"
						} else {
							return gold.buy
						}
					} else {
						return gold.sell
					}
				} else {
					return "-"
				}
			},
			buyPrice() {
				const golds = this.$store.state.golds
				if (golds && this.contractId_prop) {
					let gold = golds[this.contractId_prop]

					if (!gold) return "-"

					if (gold.buy < 0 || gold.id == 0) {
						if (gold.sell < 0 || gold.id == 0) {
							return "-"
						} else {
							return gold.sell
						}
					} else {
						return gold.buy
					}
				} else {
					return "-"
				}
			},
			sellPriceShow() {
				const decimalPoint = this.contractConfigs.tbTtDecimalPlace

				if (this.sellPrice == "-") {
					return "-"
				} else {
					const currency = this.$store.state.currency
					if (currency == "usd") {
						return this.numberFormatExtend(
							new Decimal(this.sellPrice).toFixed(decimalPoint),
							decimalPoint,
						)
					} else {
						return this.numberFormatExtend(
							Decimal.mul(
								this.sellPrice,
								this.streamingRate.streamSell,
							).toFixed(decimalPoint),
							decimalPoint,
						)
					}
				}
			},
			buyPriceShow() {
				const decimalPoint = this.contractConfigs.tbTtDecimalPlace

				if (this.buyPrice == "-") {
					return "-"
				} else {
					const currency = this.$store.state.currency
					if (currency == "usd") {
						return this.numberFormatExtend(
							new Decimal(this.buyPrice).toFixed(decimalPoint),
							decimalPoint,
						)
					} else {
						return this.numberFormatExtend(
							Decimal.mul(this.buyPrice, this.streamingRate.streamBuy).toFixed(
								decimalPoint,
							),
							decimalPoint,
						)
					}
				}
			},
			buyButtonClass() {
				return {
					"c-direction": true,
					rounded: true,
					buySellButtonActive: this.buyButtonActive_class,
				}
			},
			sellButtonClass() {
				return {
					"c-direction": true,
					rounded: true,
					buySellButtonActive: this.sellButtonActive_class,
				}
			},

			isReviewOrderButtonDisabled() {
				const contractConfig = this.contractConfigs

				if (
					contractConfig.isReviewOrderButtonDisabledBuyLimit &&
					this.direction == "buy" &&
					this.orderType == "limit"
				) {
					return true
				}
				if (
					contractConfig.isReviewOrderButtonDisabledSellMarket &&
					this.direction == "sell" &&
					this.orderType == "market"
				) {
					return true
				}
				if (
					contractConfig.isReviewOrderButtonDisabledSellLimit &&
					this.direction == "sell" &&
					this.orderType == "limit"
				) {
					return true
				}
				if (
					contractConfig.isReviewOrderButtonDisabledBuyMarket &&
					this.direction == "buy" &&
					this.orderType == "market"
				) {
					return true
				}

				if (this.preventReview) {
					return true
				}

				return false
			},

			balanceUsd() {
				return this.$store.state.balanceUsd
			},
			balanceIdr() {
				return this.$store.state.balanceIdr
			},

			quantityIntInInput: {
				get: function () {
					const temp = new Decimal(this.quantityInt)
					if (!temp.isInteger()) {
						this.quantityInt = temp.floor().toNumber()
					}

					return this.quantityInt
				},
				set: function (newValue) {
					let temp = Number(newValue)
					if (!Number.isInteger(temp)) {
						temp = Math.round(temp)
					}

					this.checkQuantityInt(temp)
				},
			},
			quantityDecimalInInput: {
				get: function () {
					return this.quantityDecimal
				},
				set: function (newValue) {
					let temp = new Decimal(newValue)
					if (temp.greaterThanOrEqualTo(1)) {
						this.quantityDecimal = new Decimal(0.9)
					} else if (temp.lessThan(0)) {
						this.quantityDecimal = new Decimal(0)
					} else {
						this.quantityDecimal = new Decimal(temp.toFixed(1))
					}
				},
			},

			quantity() {
				return Decimal.add(this.quantityInt, this.quantityDecimal)
			},
			quantityShown() {
				return this.numberFormatExtend(this.quantity)
			},

			priceGramInInput: {
				get: function () {
					return this.priceGram.toNumber()
				},
				set: function (newValue) {
					let temp = new Decimal(newValue)
					if (temp.lessThan(0)) {
						this.priceGram = new Decimal(0)
					} else {
						const decimalPlaces = this.$store.state.fractionDigit.usd
						this.priceGram = new Decimal(temp.toFixed(decimalPlaces))
					}
				},
			},

			gram() {
				if (Decimal.mul(this.quantity, this.weight).greaterThanOrEqualTo(0)) {
					return Decimal.mul(this.quantity, this.weight)
				} else {
					return new Decimal(0)
				}
			},
			gramShown() {
				return this.gram
			},

			contractPriceUsd() {
				return this.tradeTicketDataUsd.contractPrice
			},

			contractPriceIdr() {
				return this.tradeTicketDataIdr.contractPrice
			},

			contractPriceLimitShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.contractPriceUsd)
				} else {
					return Utils.currencyFormat(this.contractPriceIdr)
				}
			},

			valueUsd() {
				return this.tradeTicketDataUsd.contractValue
			},
			valueIdr() {
				return this.tradeTicketDataIdr.contractValue
			},
			valueShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.valueUsd)
				} else {
					return Utils.currencyFormat(this.valueIdr)
				}
			},

			minusSign() {
				const contractValue =
					this.currency == "idr" ? this.valueIdr : this.valueUsd
				if (this.direction == "buy" || contractValue == 0) {
					return ""
				} else {
					return "-"
				}
			},

			fee() {
				return this.tradeTicketDataUsd.fee
			},
			feeShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.tradeTicketDataUsd.fee)
				} else {
					return Utils.currencyFormat(this.tradeTicketDataIdr.fee)
				}
			},

			tax() {
				return this.tradeTicketDataUsd.tax
			},
			taxShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.tradeTicketDataUsd.tax)
				} else {
					return Utils.currencyFormat(this.tradeTicketDataIdr.tax)
				}
			},

			// Total with Contract Value, Fee, and Tax
			totalTypeA() {
				if (this.currency == "usd") {
					return this.tradeTicketDataUsd.totalTypeA
				} else {
					return this.tradeTicketDataIdr.totalTypeA
				}
			},
			totalTypeAIdr() {
				return this.tradeTicketDataIdr.totalTypeA
			},
			totalTypeAUsd() {
				return this.tradeTicketDataUsd.totalTypeA
			},

			totalTypeAShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.tradeTicketDataUsd.totalTypeA)
				} else {
					return Utils.currencyFormat(this.tradeTicketDataIdr.totalTypeA)
				}
			},

			storageFeeUsd() {
				const fractionDigit = this.$store.state.fractionDigit.usd
				return new Decimal(0).toFixed(fractionDigit)
			},

			storageFeeIdr() {
				const fractionDigit = this.$store.state.fractionDigit.idr
				return new Decimal(0).toFixed(fractionDigit)
			},

			storageFeeShown() {
				if (this.currency == "idr") {
					return Utils.currencyFormat(this.storageFeeIdr)
				} else {
					return Utils.currencyFormat(this.storageFeeUsd)
				}
			},

			fxBufferIdr() {
				return this.tradeTicketDataIdr.fxBuffer
			},
			fxBufferUsd() {
				return this.tradeTicketDataUsd.fxBuffer
			},
			fxBufferShown() {
				// return Utils.currencyFormat(this.tradeTicketDataIdr.fxBuffer)
				if (this.currency == "idr") {
					return Utils.currencyFormat(this.fxBufferIdr)
				} else {
					return Utils.currencyFormat(this.fxBufferUsd)
				}
			},

			totalUsd() {
				return this.tradeTicketDataUsd.total
			},
			totalUsdShown() {
				return Utils.currencyFormat(this.tradeTicketDataUsd.total)
			},

			totalIdr() {
				return this.tradeTicketDataIdr.total
			},
			totalIdrShown() {
				return Utils.currencyFormat(this.tradeTicketDataIdr.total)
			},

			// gopay
			adminFeeUsd() {
				return this.tradeTicketDataUsd.adminFee
			},
			adminFeeIdr() {
				return this.tradeTicketDataIdr.adminFee
			},
			adminFeeShown() {
				if (this.currency == "usd") {
					return Utils.currencyFormat(this.adminFeeUsd)
				} else {
					return Utils.currencyFormat(this.adminFeeIdr)
				}
			},

			finalAmountUsd() {
				return this.tradeTicketDataUsd.finalAmount
			},
			finalAmountUsdShown() {
				return Utils.currencyFormat(this.finalAmountUsd)
			},
			finalAmountIdr() {
				return this.tradeTicketDataIdr.finalAmount
			},
			finalAmountIdrShown() {
				return Utils.currencyFormat(this.finalAmountIdr)
			},

			pnlUsd() {
				if (
					this.$store.state.setHoldingsApiStatus == "success" &&
					this.contractId_prop != "0" &&
					this.contractId_prop
				) {
					// const holding = this.$store.getters.getHoldingByContractId(this.contractId_prop)

					// let tempPnl
					// if (this.orderType == 'market') {
					// 	tempPnl = this.$store.getters.getEstimatePNLUsdByContractIdForJfxChamp(this.contractId_prop)
					// } else {
					// 	tempPnl = this.$store.getters.getEstimatePNLUsdByContractIdForJfxChamp(this.contractId_prop, this.priceGram)
					// }

					// const pnlPerGram = Decimal.div(tempPnl, Decimal.mul(holding.quantity, this.$store.state.contractConfigs[this.contractId_prop].weightInGram)).toDecimalPlaces(4).toNumber()

					// console.log('WKWKWK PnL Holding USD', tempPnl.toNumber())
					// console.log('WKWKWK PnL per Gram USD', pnlPerGram)

					// this.$store.commit('setPnlEtc', {
					// 	pnlHoldingUsd: tempPnl,
					// 	totalGramHolding: Decimal.mul(holding.quantity, this.$store.state.contractConfigs[this.contractId_prop].weightInGram).toNumber(),
					// 	pnlPerGramUsd: pnlPerGram,

					// })

					// return Decimal.mul(pnlPerGram, this.gram).toDecimalPlaces(4, Decimal.ROUND_FLOOR).toNumber()

					const contractConfig = this.contractConfigs
					const holding = this.$store.getters.getHoldingByContractId(
						this.contractId_prop,
					)

					let contractId
					if (
						this.accountLevel == "fm" ||
						this.accountLevel == "ib" ||
						this.accountLevel == "lp"
					) {
						contractId = holding.contractId
					} else {
						contractId = holding.contract_id
					}

					if (!this.$store.state.golds[contractId]) {
						return "-"
					}

					let contractPriceUsd =
						this.$store.state.golds[contractId].contractPriceSell
					if (this.orderType == "limit") {
						contractPriceUsd = Decimal.mul(
							this.priceGram,
							contractConfig.weightInGram,
						).toNumber()
					}

					let averageTotalCostIncFeeAndTax
					if (this.accountLevel == "fm" || this.accountLevel == "ib") {
						averageTotalCostIncFeeAndTax =
							holding.averageTotalCostIncFeeAndTaxUsd
					} else {
						averageTotalCostIncFeeAndTax = holding.avg_total_cost
					}

					const rate = this.streamingRate.streamSell

					const pnlUsd =
						TradingFormula.reports.holdings.getEstimatePnlForJfxChamp({
							contractPriceUsd: contractPriceUsd,
							averageTotalCostIncFeeAndTax: averageTotalCostIncFeeAndTax,
							quantityHolding: holding.quantity,
							contractWeight: this.contractConfigs.weightInGram,
							gramOrder: this.gram.toNumber(),
							currency: "usd",
							rate: rate,
						})

					return new Decimal(pnlUsd).toNumber()
				}

				return null
			},
			pnlIdr() {
				if (
					this.$store.state.setHoldingsApiStatus == "success" &&
					this.contractId_prop != "0" &&
					this.contractId_prop
				) {
					// const holding = this.$store.getters.getHoldingByContractId(this.contractId_prop)

					// let tempPnl
					// if (this.orderType == 'market') {
					// 	tempPnl = this.$store.getters.getEstimatePNLIdrByContractIdForJfxChamp(this.contractId_prop)
					// } else {
					// 	tempPnl = this.$store.getters.getEstimatePNLIdrByContractIdForJfxChamp(this.contractId_prop, this.priceGram)
					// }

					// const pnlPerGram = Decimal.div(tempPnl, Decimal.mul(holding.quantity, this.$store.state.contractConfigs[this.contractId_prop].weightInGram)).toDecimalPlaces(4).toNumber()

					// console.log('WKWKWK PnL Holding IDR', tempPnl.toNumber())
					// console.log('WKWKWK Total Gram Holding', Decimal.mul(holding.quantity, this.$store.state.contractConfigs[this.contractId_prop].weightInGram).toNumber())
					// console.log('WKWKWK PnL per Gram IDR', pnlPerGram)

					// this.$store.commit('setPnlEtc', {
					// 	pnlHoldingIdr: tempPnl,
					// 	totalGramHoldingIdr: Decimal.mul(holding.quantity, this.$store.state.contractConfigs[this.contractId_prop].weightInGram).toNumber(),
					// 	pnlPerGramIdr: pnlPerGram,

					// })

					// return Decimal.mul(pnlPerGram, this.gram).toDecimalPlaces(4, Decimal.ROUND_FLOOR).toNumber()

					const contractConfig = this.contractConfigs
					const holding = this.$store.getters.getHoldingByContractId(
						this.contractId_prop,
					)

					if (this.streamingRate.streamSell == -1 && this.currency != "usd") {
						return "-"
					}

					let contractId
					if (
						this.accountLevel == "fm" ||
						this.accountLevel == "ib" ||
						this.accountLevel == "lp"
					) {
						contractId = holding.contractId
					} else {
						contractId = holding.contract_id
					}

					if (!this.$store.state.golds[contractId]) {
						return "-"
					}

					let contractPriceUsd =
						this.$store.state.golds[contractId].contractPriceSell
					if (this.orderType == "limit") {
						contractPriceUsd = Decimal.mul(
							this.priceGram,
							contractConfig.weightInGram,
						).toNumber()
					}

					let averageTotalCostIncFeeAndTax
					if (this.accountLevel == "fm" || this.accountLevel == "ib") {
						averageTotalCostIncFeeAndTax =
							holding.averageTotalCostIncFeeAndTaxIdr
					} else {
						averageTotalCostIncFeeAndTax = holding.avg_total_cost_idr
					}

					const rate = this.streamingRate.streamSell

					const pnlIdr =
						TradingFormula.reports.holdings.getEstimatePnlForJfxChamp({
							contractPriceUsd: contractPriceUsd,
							averageTotalCostIncFeeAndTax: averageTotalCostIncFeeAndTax,
							quantityHolding: holding.quantity,
							contractWeight: this.contractConfigs.weightInGram,
							gramOrder: this.gram.toNumber(),
							currency: "idr",
							rate: rate,
						})

					return new Decimal(pnlIdr).toNumber()
				}

				return null
			},

			estimasiProfitIdr() {
				if (this.direction == "buy") {
					return 0
				}

				const stack = this.$store.getters[
					"goldInventories/getTradeGoldInventoriesByContractId"
				](this.contractId_prop).map((item) => ({
					gram: item.remaining_quantity,
					pricePerGram: item.cost_per_gram_idr,
				}))

				let metalValueAtDate
				metalValueAtDate = this.totalIdr

				const estimasiProfit = getPnl({
					stack: stack,
					gramSell: this.gram.toNumber(),
					metalValueAtDate: metalValueAtDate,
					currency: "idr",
					paymentMethod: this.$store.getters.paymentMethod,
				})

				return estimasiProfit.pnl
			},

			estimasiProfitUsd() {
				if (this.direction == "buy") {
					return 0
				}

				const stack = this.$store.getters[
					"goldInventories/getTradeGoldInventoriesByContractId"
				](this.contractId_prop).map((item) => ({
					gram: item.remaining_quantity,
					pricePerGram: item.cost_per_gram_usd,
				}))

				let metalValueAtDate
				metalValueAtDate = this.totalUsd

				const estimasiProfit = getPnl({
					stack: stack,
					gramSell: this.gram.toNumber(),
					metalValueAtDate: metalValueAtDate,
					currency: "usd",
					paymentMethod: this.$store.getters.paymentMethod,
				})

				return estimasiProfit.pnl
			},

			estimasiProfitShown() {
				if (this.$store.state.goldInventories.apiStatus == "loading") {
					return "-"
				}

				const estimasiProfit =
					this.currency == "idr"
						? this.estimasiProfitIdr
						: this.estimasiProfitUsd

				// if estimated profit < 0 show minus sign before the currency
				let sign = ""
				if (new Decimal(estimasiProfit).lessThan(0)) {
					sign = "-"
				} else if (new Decimal(estimasiProfit).greaterThan(0)) {
					sign = "+"
				}

				// if payment method is rped fraction digit is the same as the currency, else it is 0
				const fractionDigit = this.$store.state.fractionDigit[this.currency]

				return (
					`${sign}${this.currencySymbol} ` +
					Utils.currencyFormat(
						new Decimal(estimasiProfit).abs().toFixed(fractionDigit),
						this.currency,
					)
				)
			},

			priceGram15PercentAway() {
				let price = "-"
				if (this.direction == "buy") {
					price = this.buyPrice
				} else {
					price = this.sellPrice
				}
				if (price != "-") {
					price = new Decimal(price)
					let temp = new Decimal(this.priceGram)

					if (
						temp.lessThanOrEqualTo(
							price.minus(price.times(this.minMaxLimitPrice)),
						) ||
						temp.greaterThanOrEqualTo(
							price.plus(price.times(this.minMaxLimitPrice)),
						)
					) {
						return true
					}
				}
				return false
			},

			alert15PercentAwayStyle() {
				let display = "none"
				if (this.priceGram15PercentAway) {
					display = "block"
				}
				return {
					color: "#4D0E00",
					display: display,
				}
			},

			isContractStatusDisabled() {
				if (this.ticker_prop.includes("K1KG")) {
					return true
				} else {
					return false
				}
			},

			evwsInProgress() {
				return 0
			},

			withdrawalsInProgress() {
				return 0
			},

			disableButton() {
				if (!this.disclaimerCheck && this.direction == "sell") {
					return true
				} else {
					return false
				}
			},
		},

		watch: {
			contractId_prop() {
				// // if available trade gold quantity for sell is 0, set quantityInt to 0, else 1
				// if (this.direction == 'sell' && this.$store.getters['goldBalanceNew/getAvailableTradeGoldQuantityByContractId'](this.contractId_prop) == 0) {
				// 	this.quantityInt = 0
				// } else {
				// 	this.quantityInt = 1
				// }
			},

			quantityIntInInput(newValue) {
				if (this.$refs.quantityMarket) {
					this.$refs.quantityMarket.style.width = `${
						newValue.toString().length * 10 + 4
					}px`
				}
			},

			ticker_prop() {
				this.quantityDecimal = 0
				this.isOpen = true

				this.setPriceGramDefault()
			},

			limitOrderDate(newValue) {
				const now = new Date()
				const expiryDate = new Date(newValue)

				const temp = new Date(now.setHours(now.getHours() + 1))

				if (expiryDate < temp) {
					const day =
						temp.getDate() < 10 ? "0" + temp.getDate() : temp.getDate()
					const month =
						temp.getMonth() + 1 < 10
							? "0" + (temp.getMonth() + 1)
							: temp.getMonth() + 1
					const year =
						temp.getFullYear() < 10
							? "0" + temp.getFullYear()
							: temp.getFullYear()
					const hours =
						temp.getHours() < 10 ? "0" + temp.getHours() : temp.getHours()
					const minutes =
						temp.getMinutes() < 10 ? "0" + temp.getMinutes() : temp.getMinutes()

					this.limitOrderDate =
						year + "-" + month + "-" + day + " " + hours + ":" + minutes
				}
			},

			directionDefault_prop(newValue) {
				// set default direction
				this.changeDirection(newValue)
			},
		},

		created() {
			this.setPriceGramDefault()

			// fetch ROG event detail
			if (this.$store.getters.paymentMethod == "rped") {
				this.$store.dispatch("events/fetchEvent", EVENT_KEYS.rog)
			}
		},

		mounted() {
			// setTimeout(() => {
			// 	// this.$refs.reviewOrderRef.openReviewOrder()
			// 	this.openTradeTicket()
			// }, 1000)
		},

		methods: {
			openTradeTicket() {
				this.$refs.modalRef.openModal()

				// fetch gold inventories every 3 seconds
				this.$store.dispatch("goldInventories/fetchAllInventories", {
					user_id: this.$store.state.userId,
					type: "TRADE",
				})
				this.setIntervalFetchGoldInventory = setInterval(() => {
					this.$store.dispatch("goldInventories/fetchAllInventories", {
						user_id: this.$store.state.userId,
						type: "TRADE",
					})
				}, 3000)

				this.setPriceGramDefault()
			},

			closeTradeTicket(type = "default") {
				// type: default or afterTrade
				if (type == "afterTrade") {
					// emit to parent
					this.$emit("afterTradeSuccess")
				}

				this.resetValue()

				this.$refs.modalRef.closeModal()
			},

			setPriceGramDefault() {
				const golds = this.$store.state.golds
				if (!golds || !this.contractId_prop) {
					this.priceGram = new Decimal(0)
					return
				}

				const gold = golds[this.contractId_prop]
				if (!gold) {
					this.priceGram = new Decimal(0)
					return
				}

				let temp =
					this.direction == "buy" ? gold.pricePerGramBuy : gold.pricePerGramSell

				if (temp == "-") {
					this.priceGram = new Decimal(0)
				} else {
					const decimalPlaces = this.$store.state.fractionDigit.usd
					this.priceGram = new Decimal(temp).toDecimalPlaces(decimalPlaces)
				}
			},

			updateQuantityInt(totalGram) {
				this.quantityInt = Decimal.div(
					totalGram,
					this.contractConfigs.weightInGram,
				).toNumber()
			},

			updatePriceGram(price) {
				this.priceGram = new Decimal(price)
			},

			goToGoldDripSnk() {
				// $router.push({ name: 'Promo' })
				const routeData = this.$router.resolve({ name: "Promo" })
				window.open(routeData.href, "_blank")
			},

			openDepth() {
				// this.isDepthOpen = true
				this.$refs.depthRef.openDepth()
			},
			closeDepth() {
				// this.isDepthOpen = false
				this.$refs.depthRef.closeDepth()
			},

			increaseQuantityInt() {
				let temp = Number(this.quantityInt)
				temp += 1

				this.checkQuantityInt(temp)
			},
			decreaseQuantityInt() {
				let temp = Number(this.quantityInt)
				temp -= 1

				this.checkQuantityInt(temp)
			},

			checkQuantityInt(newValue) {
				if (newValue < 0) {
					this.quantityInt = 0
				} else if (
					this.direction == "sell" &&
					new Decimal(newValue).greaterThan(
						this.$store.getters[
							"goldBalanceNew/getAvailableTradeGoldQuantityByContractId"
						](this.contractId_prop),
					)
				) {
					this.quantityInt = this.$store.getters[
						"goldBalanceNew/getAvailableTradeGoldQuantityByContractId"
					](this.contractId_prop)
				} else {
					this.quantityInt = newValue
				}
			},

			increaseQuantityDecimal() {
				// let temp = Number(this.quantityDecimal) * 10
				// temp = (temp + 1) / 10
				let temp = new Decimal(this.quantityDecimal)
				temp = temp.plus(0.1)
				if (temp.greaterThanOrEqualTo(1)) {
					this.quantityDecimal = new Decimal(0.9)
				} else if (temp.lessThan(0)) {
					this.quantityDecimal = new Decimal(0)
				} else {
					this.quantityDecimal = temp
				}
			},
			decreaseQuantityDecimal() {
				// let temp = Number(this.quantityDecimal) * 10
				// temp = (temp - 1) / 10
				let temp = new Decimal(this.quantityDecimal)
				temp = temp.sub(0.1)
				if (temp.greaterThanOrEqualTo(1)) {
					this.quantityDecimal = new Decimal(0.9)
				} else if (temp.lessThan(0)) {
					this.quantityDecimal = new Decimal(0)
				} else {
					this.quantityDecimal = temp
				}
			},

			increasePriceGram() {
				let temp = new Decimal(this.priceGram)
				if (
					this.contractId_prop == this.$store.state.contractIds.contract_001g
				) {
					temp = temp.plus(0.01)
				} else if (
					this.contractId_prop == this.$store.state.contractIds.contract_1g
				) {
					temp = temp.plus(0.01)
				} else {
					temp = temp.plus(0.01)
				}

				if (temp < 0) {
					this.priceGram = new Decimal(0)
				} else {
					this.priceGram = temp
				}
			},
			decreasePriceGram() {
				let temp = new Decimal(this.priceGram)
				if (
					this.contractId_prop == this.$store.state.contractIds.contract_001g
				) {
					temp = temp.sub(0.01)
				} else if (
					this.contractId_prop == this.$store.state.contractIds.contract_1g
				) {
					temp = temp.sub(0.01)
				} else {
					temp = temp.sub(0.01)
				}

				if (temp.lessThan(0)) {
					this.priceGram = new Decimal(0)
				} else {
					this.priceGram = temp
				}
			},

			increaseLimitPrice() {
				this.limitPrice = Decimal.add(this.limitPrice, 0.5)
			},
			decreaseLimitPrice() {
				let temp = new Decimal(this.limitPrice)
				if (temp.lessThan(0)) {
					this.limitPrice = 0
				} else {
					this.limitPrice = Decimal.sub(this.limitPrice, 0.5)
				}
			},

			confirmSubmit() {
				Alert.open({
					type: "confirm",
					title: "Are you sure want to submit this order?",
					description: "",
					buttonCloseClass: "ga-batal-submit-order",
					buttonConfirmClass: "ga-ya-submit-order",
					onConfirm: () => {
						this.submitOrder()
					},
				})
			},

			showReviewOrder() {
				// LOG for QA =========================================
				const holding = this.$store.getters.getHoldingByContractId(
					this.contractId_prop,
				)

				console.log("⭐⭐⭐⭐⭐⭐⭐⭐")
				console.log("Contract: " + this.name)
				console.log("Contract ID: " + this.contractId_prop)
				console.log("Direction: " + this.direction)
				console.log("Order Type: " + this.orderType)
				console.log("Rate SELL: " + this.streamingRate.streamSell)
				console.log(
					"Contract Price SELL USD: " +
						this.$store.state.golds[holding.contract_id].contractPriceSell,
				)
				console.log("Contract Value USD: " + this.valueUsd)
				console.log("Quantity Order: " + this.quantity)
				console.log("Gram Order: " + this.gram)

				if (holding) {
					console.log("Quantity Holding: " + holding.quantity)
					console.log(
						"Gram Holding: " +
							Decimal.mul(holding.quantity, this.weight).toFixed(),
					)
				} else {
					console.log("Holding Quantity: 0")
					console.log("Holding Gram: 0")
				}

				console.log("Average Total Cost USD: " + holding.avg_total_cost)
				console.log("Average Total Cost IDR: " + holding.avg_total_cost_idr)

				console.log("PNL AKHIR USD: " + this.pnlUsd)
				console.log("PNL AKHIR IDR: " + this.pnlIdr)
				// ====================================================================

				let priceTemp = 0
				let tempStream = 1

				let balance = new Decimal(this.$store.state.availableTradeBalanceUsd)
				let balanceIdr = new Decimal(this.$store.state.availableTradeBalanceIdr)

				if (this.direction == "buy") {
					priceTemp = this.buyPrice

					if (this.currency == "idr") {
						tempStream = this.streamingRate.streamBuy
					}
				} else {
					priceTemp = this.sellPrice

					if (this.currency == "idr") {
						tempStream = this.streamingRate.streamSell
					}
				}

				// check if market is closed
				if (this.$store.state.marketStatus == "close") {
					if (this.$store.state.marketCloseType == 2) {
						Swal.fire({
							background: "#191f31",
							title: "The market is currently closed",
							html: " Thanksgiving Holiday Info<br>The market will be closed:<br><br>Friday, Nov 29, 02:30 - 06:00 WIB<br>Saturday, Nov 30, 02:45 - Monday, Des 2, 06:00 WIB<br><br>Normal operations will resume afterward.<br>- JFXGOLD X ",
						})
					} else {
						Swal.fire({
							background: "#191f31",
							title: "The market is currently closed",
						})
					}

					return
				}

				// check if contract is disabled
				if (this.isContractStatusDisabled) {
					Swal.fire({
						background: "#191f31",
						title: "Pre Order Trading Contract.",
						html: "Please contact your Brokerage firm for this transaction.",
					})

					return
				}

				// check if validity is set
				if (this.orderType == "limit" && !this.validity) {
					Swal.fire({
						background: "#191f31",
						html: "<span style='color: white;'>Please select order validity.</span>",
					})

					return
				}

				// check if validity and limit order date is set
				if (
					this.orderType == "limit" &&
					this.validity == "GTD" &&
					!this.limitOrderDate
				) {
					Swal.fire({
						background: "#191f31",
						html: "<span style='color: white;'>Please set limit order date.</span>",
					})

					return
				}

				// check if total amount is less than or equal to zero
				if (new Decimal(this.finalAmountUsd).lessThanOrEqualTo(0)) {
					Swal.fire({
						background: "#191f31",
						html: "<span style='color: white;'>Order total must be greater than zero.</span>",
					})

					return
				}

				// if (this.orderType == 'limit' && this.priceGram15PercentAway && this.contractConfigs.contractType == 'kau') {
				// 	Swal.fire({
				// 		background: '#191f31',
				// 		html: 'The price of this order is ' + Utils.currencyFormat(Decimal.mul(this.minMaxLimitPrice, 100).toFixed(2)) + '% away from current market price.',
				// 	})

				// 	return
				// }

				// check if balance USD is enough
				if (balance.lessThan(this.finalAmountUsd) && this.direction == "buy") {
					if (
						this.$store.getters.paymentMethod == "gopay" &&
						!this.$store.getters.isGopayLinked
					) {
						// if gopay, check if gopay is linked. If not, then continue order
					} else {
						Swal.fire({
							background: "#191f31",
							html: "<span style='color: white;'>You don't have enough available trade balance.</span>",
						})

						return
					}
				}

				// check if balance IDR is enough
				if (
					balanceIdr.lessThan(this.finalAmountIdr) &&
					this.direction == "buy"
				) {
					if (
						this.$store.getters.paymentMethod == "gopay" &&
						!this.$store.getters.isGopayLinked
					) {
						// if gopay, check if gopay is linked. If not, then continue order
					} else {
						Swal.fire({
							background: "#191f31",
							html: "<span style='color: white;'>You don't have enough available trade balance.</span>",
						})

						return
					}
				}

				// if (this.direction == 'sell' && new Decimal(this.quantity).greaterThan(this.$store.getters['goldBalanceNew/getAvailableTradeGoldQuantityByContractId'](this.contractId_prop))) {
				// 	Swal.fire({
				// 		background: '#191f31',
				// 		html: "<span style='color: white;'>You don't have enough " + this.$store.getters.getContractConfigs(this.contractId_prop).name + ' gold.',
				// 	})

				// 	return
				// }

				let contractPriceTemp

				// set validUntil
				let validUntil
				if (this.validity == "GTC") {
					validUntil = "Cancelled"
				} else {
					let month = [
						"Jan",
						"Feb",
						"Mar",
						"Apr",
						"May",
						"Jun",
						"Jul",
						"Aug",
						"Sep",
						"Oct",
						"Nov",
						"Dec",
					]
					let hours =
						this.expiryDate.getHours() < 10
							? `0${this.expiryDate.getHours()}`
							: this.expiryDate.getHours()
					let minutes =
						this.expiryDate.getMinutes() < 10
							? `0${this.expiryDate.getMinutes()}`
							: this.expiryDate.getMinutes()

					validUntil =
						this.expiryDate.getDate() +
						" " +
						month[this.expiryDate.getMonth()] +
						" " +
						this.expiryDate.getFullYear()
				}

				// set contractPrice
				let contractPrice
				if (this.orderType == "market") {
					if (this.contractConfigs.contractType == "kau") {
						contractPrice = Decimal.mul(priceTemp, tempStream).toNumber()
					} else {
						contractPrice = Decimal.mul(this.weight, priceTemp)
							.times(tempStream)
							.toNumber()
					}
				} else {
					contractPrice = this.contractPriceUsd
				}

				const reviewOrderDataTemp = {
					contractId: this.contractId_prop,
					codeName: this.codeName,
					name: this.contractConfigs.tradeTicketName,
					ticker: this.ticker_prop,
					direction: this.direction,
					orderType: this.orderType,
					validUntil: validUntil,
					contractPrice: contractPrice,
					quantity: this.quantity,
					gram: this.gram,
					priceGram: this.priceGram,
					contractValueIdr: this.valueIdr,
					contractValueUsd: this.valueUsd,
					feeIdr: this.tradeTicketDataIdr.fee,
					feeUsd: this.tradeTicketDataUsd.fee,
					taxIdr: this.tradeTicketDataIdr.tax,
					taxUsd: this.tradeTicketDataUsd.tax,
					totalTypeAIdr: this.tradeTicketDataIdr.totalTypeA,
					totalTypeAUsd: this.tradeTicketDataUsd.totalTypeA,
					storageFeeIdr: this.storageFeeIdr,
					storageFeeUsd: this.storageFeeUsd,
					fxBufferIdr: this.tradeTicketDataIdr.fxBuffer,
					fxBufferUsd: this.tradeTicketDataUsd.fxBuffer,
					totalIdr: this.tradeTicketDataIdr.total,
					totalUsd: this.tradeTicketDataUsd.total,
					adminFeeIdr: this.tradeTicketDataIdr.adminFee,
					adminFeeUsd: this.tradeTicketDataUsd.adminFee,
					finalAmountIdr: this.tradeTicketDataIdr.finalAmount,
					finalAmountUsd: this.tradeTicketDataUsd.finalAmount,
					estimasiProfitShown: this.estimasiProfitShown,
				}

				this.reviewOrderData = reviewOrderDataTemp

				if (
					this.$store.getters.paymentMethod == "gopay" &&
					this.direction == "buy"
				) {
					Alert.open({
						type: "confirm",
						showIcon: false,
						title: "Order Confirmation",
						description:
							"Has your order been set correctly? <br /> Click Continue to Payment to place your order and proceed to the payment process",
						buttonConfirmText: "Continue to Payment",
						buttonDeclineText: "Review Again",
						alertClass: "w-118.75",
						onConfirm: () => {
							this.submitOrder()
						},
					})
				} else {
					this.$refs.reviewOrderRef.openReviewOrder()
				}
			},

			async submitOrder() {
				Alert.open({
					type: "loading",
				})

				// set limit price
				const limitPrice =
					this.orderType == "market"
						? 0
						: Decimal.mul(this.priceGram, this.weightMultiplication).toNumber()

				// set validity and expired date
				let validity = this.validity
				let expiredDate = new Date(this.expiryDate).toISOString() // default GTD

				if (this.orderType == "market") {
					validity = "GTC"
				} else if (this.validity == "GTC") {
					expiredDate = new Date(
						new Date().setMonth(new Date().getMonth() + 1),
					).toISOString() // set +1 month from now
				}

				const dataPayload = {
					user_id: this.$store.state.userId,
					contract_id: String(this.contractId_prop),
					direction: this.direction,
					quantity: Decimal.mul(
						this.quantity,
						this.contractConfigs.weightCorrection,
					).toNumber(),
					order_type: this.orderType,
					limit_price: limitPrice,
					validity: validity,
					fee: this.fee,
					tax: this.tax,
					fx_buffer_idr: new Decimal(
						this.tradeTicketDataIdr.fxBuffer,
					).toNumber(),
					fx_buffer_usd: new Decimal(
						this.tradeTicketDataUsd.fxBuffer,
					).toNumber(),
					payment_idr: this.finalAmountIdr,
					payment_usd: this.finalAmountUsd,
					est_pnl_idr: this.pnlIdr,
					est_pnl_usd: this.pnlUsd,
					type: "TRADE", //TRADE, GTMU, GTMH
					is_feature: true,
					to_feature: "TRADE", //TRADE, GTMU, GTMH
					pnlEtc: this.$store.state.pnlEtc,
					payment_method: this.$store.getters.paymentMethod,
					// for debugging
					contract_value_usd: this.valueUsd,
					contract_value_idr: this.valueIdr,
					price_per_gram_usd: this.pricePerGramUsd,
					rate: this.rate,
					unrealized_pnl_idr: this.estimasiProfitIdr,
					unrealized_pnl_usd: this.estimasiProfitUsd,
				}

				// add payment_method and return_url property if order type is market
				if (this.orderType == "market") {
					dataPayload.return_url =
						window.location.origin +
						`${this.environment == "development" ? "/" : ""}` +
						this.$router.resolve({ name: "Reports" }).href
					dataPayload.return_error_url =
						window.location.origin +
						`${this.environment == "development" ? "/" : ""}` +
						this.$router.resolve({ name: "Trade" }).href
				}

				// add expired_date property if order type is limit
				if (this.orderType == "limit") {
					dataPayload.expired_date = expiredDate
				}

				try {
					const urlAddOrder =
						this.contractConfigs.contractType == "kau"
							? "/v2/igx/add_kau_order"
							: "/v2/igx/add_order"

					const response = await axios.post(urlAddOrder, dataPayload)

					const r1 = (((response || {}).data || {}).attributes || {}).status
					if (r1 == "cancel") {
						throw new Error("cancel")
					}

					if (
						this.$store.getters.paymentMethod == "gopay" &&
						this.direction == "buy"
					) {
						// set Payment Confirmation (Review Order)

						let responseData
						if (this.$store.getters.paymentMethod == "rped") {
							responseData = response.data.data.body.body.attributes
						} else {
							responseData = response.data.data.body.attributes
						}

						const pricePerGramIdr = new Decimal(responseData.amountPerGramIdr)
							.mul(this.contractConfigs.weightCorrection)
							.toFixed(this.$store.state.fractionDigit.idr)
						const contractPriceIdr = Decimal(responseData.amountPerGramIdr)
							.mul(this.contractConfigs.weightInGram)
							.toFixed(this.$store.state.fractionDigit.idr)

						// IDR
						const contractValueIdr = new Decimal(
							responseData.amountIdr,
						).toFixed(this.$store.state.fractionDigit.idr)
						const feeIdr = new Decimal(responseData.feeIdr).toFixed(
							this.$store.state.fractionDigit.feeIdr,
						)
						const taxIdr = new Decimal(responseData.taxIdr).toFixed(
							this.$store.state.fractionDigit.taxIdr,
						)
						let totalTypeAIdr
						if (this.direction == "buy") {
							totalTypeAIdr = new Decimal(contractValueIdr)
								.plus(feeIdr)
								.plus(taxIdr)
								.toDecimalPlaces(0)
								.toFixed(this.$store.state.fractionDigit.idr)
						} else {
							totalTypeAIdr = new Decimal(contractValueIdr)
								.minus(feeIdr)
								.minus(taxIdr)
								.toDecimalPlaces(0, Decimal.ROUND_DOWN)
								.toFixed(this.$store.state.fractionDigit.idr)
						}

						this.$set(this.reviewOrderData, "pricePerGramIdr", pricePerGramIdr)
						this.$set(
							this.reviewOrderData,
							"contractPriceIdr",
							contractPriceIdr,
						)
						this.$set(
							this.reviewOrderData,
							"contractValueIdr",
							contractValueIdr,
						)
						this.$set(this.reviewOrderData, "feeIdr", feeIdr)
						this.$set(this.reviewOrderData, "taxIdr", taxIdr)
						this.$set(this.reviewOrderData, "totalTypeAIdr", totalTypeAIdr)
						this.$set(
							this.reviewOrderData,
							"fxBufferIdr",
							new Decimal(responseData.bufferIdr).toFixed(
								this.$store.state.fractionDigit.fxBufferIdr,
							),
						)
						this.$set(
							this.reviewOrderData,
							"totalIdr",
							new Decimal(responseData.paymentAmountIdr).toFixed(
								this.$store.state.fractionDigit.idr,
							),
						)
						this.$set(
							this.reviewOrderData,
							"adminFeeIdr",
							new Decimal(responseData.paymentAdminFee).toFixed(
								this.$store.state.fractionDigit.idr,
							),
						)
						this.$set(
							this.reviewOrderData,
							"finalAmountIdr",
							new Decimal(responseData.paymentTotalAmountIdr).toFixed(
								this.$store.state.fractionDigit.idr,
							),
						)

						// USD
						const contractValueUsd = Decimal.div(
							responseData.amountIdr,
							this.rate,
						).toFixed(this.$store.state.fractionDigit.usd)
						const feeUsd = Decimal.div(responseData.feeIdr, this.rate).toFixed(
							this.$store.state.fractionDigit.feeUsd,
						)
						const taxUsd = Decimal.div(responseData.taxIdr, this.rate).toFixed(
							this.$store.state.fractionDigit.taxUsd,
						)
						const fxBufferUsd = Decimal.div(
							responseData.bufferIdr,
							this.rate,
						).toFixed(this.$store.state.fractionDigit.fxBufferUsd)
						const totalTypeAUsd = TradingFormula.tradeTicket.getTotalTypeA({
							paymentMethod: "gopay",
							contractValueUsd: contractValueUsd,
							direction: this.direction,
							currency: "usd",
							rateUsdToCurrency: this.rate,
						})
						const totalUsd = TradingFormula.tradeTicket.getTotal({
							paymentMethod: "gopay",
							contractValueUsd: contractValueUsd,
							direction: this.direction,
							orderType: this.orderType,
							currency: "usd",
							rateUsdToCurrency: this.rate,
						})
						const adminFeeUsd = TradingFormula.tradeTicket.calculateAdminFee({
							total: totalUsd,
							direction: this.direction,
							currency: "usd",
							rateCurrencyToIdr: this.rate,
						})
						const finalAmountUsd =
							TradingFormula.tradeTicket.calculateFinalAmount({
								paymentMethod: "gopay",
								total: totalUsd,
								adminFee: adminFeeUsd,
								direction: this.direction,
								currency: "usd",
							})

						this.$set(
							this.reviewOrderData,
							"pricePerGramUsd",
							Decimal.div(pricePerGramIdr, this.rate).toFixed(
								this.$store.state.fractionDigit.usd,
							),
						)
						this.$set(
							this.reviewOrderData,
							"contractPriceUsd",
							Decimal.div(contractPriceIdr, this.rate).toFixed(
								this.$store.state.fractionDigit.usd,
							),
						)
						this.$set(
							this.reviewOrderData,
							"contractValueUsd",
							contractValueUsd,
						)
						this.$set(this.reviewOrderData, "feeUsd", feeUsd)
						this.$set(this.reviewOrderData, "taxUsd", taxUsd)
						this.$set(this.reviewOrderData, "totalTypeAUsd", totalTypeAUsd)
						this.$set(this.reviewOrderData, "fxBufferUsd", fxBufferUsd)
						this.$set(this.reviewOrderData, "totalUsd", totalUsd)
						this.$set(this.reviewOrderData, "adminFeeUsd", adminFeeUsd)
						this.$set(this.reviewOrderData, "finalAmountUsd", finalAmountUsd)

						this.gopayRedirectUrl = responseData.redirectUrl
						this.snapToken = responseData.paymentToken

						Alert.close()

						this.$refs.reviewOrderRef.startTimerGopay()

						this.$refs.reviewOrderRef.openReviewOrder()

						return
					}

					Alert.open({
						type: "success",
						title: "Order Berhasil",
						description: "",
						showBanner: this.direction == "buy",
						bannerStyle: "info",
						bannerMessage:
							"Instant RoG akan masuk ke saldo RPED ketika transaksi filled/partial filled.Informasi cashback akan dikirim via email",
						buttonCloseClass: "ga-closed-order-success",
						onClose: () => {
							this.afterTradeSuccess()

							this.closeReviewOrder()
							this.closeTradeTicket("afterTrade")
						},
					})

					console.log("berhasil order", response)
				} catch (error) {
					let errorTitle = "Order Gagal"
					let errorText = "Please try again later"

					if (error.response) {
						/*
						 * The request was made and the server responded with a
						 * status code that falls out of the range of 2xx
						 */
						console.log(error.response.data)
						console.log(error.response.status)
						console.log(error.response.headers)

						if (error.response.status == 497) {
							errorText = " Under maintenance "
						} else if (error.response.data.data) {
							if (error.response.data.data.err_message) {
								errorText = error.response.data.data.err_message
							} else if (error.response.data.data.message) {
								errorText = error.response.data.data.message
							} else {
								errorText = error.response.data.data[0].detail
							}
						} else {
							errorText = error.response.data.message
						}
					} else if (error.request) {
						/*
						 * The request was made but no response was received, `error.request`
						 * is an instance of XMLHttpRequest in the browser and an instance
						 * of http.ClientRequest in Node.js
						 */
						console.log(error.request)

						errorTitle = "Server appears to be offline"
						errorText = "Please try again later"
					} else {
						// Something happened in setting up the request and triggered an Error
						console.log(error.message)
					}

					Alert.open({
						type: "error",
						title: errorTitle,
						description: errorText,
					})

					console.log("Gagal order", error.config)
				}
			},

			async openGopayPaymentPage() {
				// this.$refs.gopayPaymentPageRef.openGopayPaymentPage(this.gopayRedirectUrl)

				try {
					const result = await this.payMidtrans(this.snapToken)

					this.$store.commit("setReportToShow_mut", "transactions")
					this.$router.push({ name: "Reports" })
				} catch (error) {
					console.log("Gagal openGopayPaymentPage", error)

					if (error.message == "error") {
						this.closeReviewOrder()
					}
				}
			},

			orderTypeFunction(type, e) {
				if (type == 1) {
					this.orderType = "market"
					this.idForm = "formMarket"
				} else {
					this.orderType = "limit"
					this.idForm = "formLimit"
				}
			},
			until(until) {
				if (until == 1) {
					this.validity = "GTC"
				} else {
					this.validity = "GTD"
				}
			},

			closeReviewOrder() {
				if (
					this.$store.state.marketInquiryStatus == "loading" &&
					this.orderType == "market"
				) {
					// cancel()
					this.$store.commit("CHANGE_MARKET_INQUIRY_STATUS", "idle")
				}

				this.$refs.reviewOrderRef.closeReviewOrder()
			},

			changeDirection(direction) {
				if (direction == "sell") {
					this.direction = "sell"
					this.buyButtonActive_class = false
					this.sellButtonActive_class = true
				} else if (direction == "buy") {
					this.direction = "buy"
					this.buyButtonActive_class = true
					this.sellButtonActive_class = false
				}

				this.checkQuantityInt(this.quantityInt)
			},

			resetValue() {
				// clear interval fetch gold inventories
				if (this.setIntervalFetchGoldInventory) {
					clearInterval(this.setIntervalFetchGoldInventory)
					this.setIntervalFetchGoldInventory = null
				}

				this.changeDirection(this.directionDefault_prop)

				// // if available trade gold == 0, set quantityInt to 0
				// if (this.$store.getters['goldBalanceNew/getAvailableTradeGoldQuantityByContractId'](this.contractId_prop) == 0) {
				// 	this.quantityInt = 0
				// } else {
				// 	this.quantityInt = 1
				// }

				this.quantityInt = 0
				this.quantityDecimal = 0

				this.preventReview = false

				this.isOpen = true
			},
			refreshBalance() {
				location.reload()
			},
			exitCloseMarket() {
				this.isOpen = false
			},
			setGetDepositCooldown() {
				this.$store.commit("CHANGE_GET_DEPOSIT_COOLDOWN_STATUS", true)
				localStorage.setItem(
					"getDepositCooldownExpiredTime",
					Date.now() + 120000,
				) // 2 minutes in milisecond
				clearInterval(this.setIntervalGetDepositCooldown)
				this.setIntervalGetDepositCooldown = setInterval(() => {
					let dateExpired = Number(
						localStorage.getItem("getDepositExecuteTime"),
					)
					let dateNow = Date.now()
					if (dateExpired) {
						if (
							dateNow > dateExpired &&
							!this.$store.state.getDepositIsCooldown
						) {
							localStorage.removeItem("getDepositExecuteTime")
							clearInterval(this.setIntervalGetDepositCooldown)

							this.$store.dispatch("setBalance")
						}
					}
				}, 1000)
			},

			expandBalance() {
				const element = document.getElementsByClassName("balance-section")
				element[0].classList.toggle("expanded")

				if (element[0].classList.contains("expanded")) {
					this.arrowDirectionBalance = "up"
				} else {
					this.arrowDirectionBalance = "down"
				}
			},
			expandHoldings() {
				const element = document.getElementsByClassName("holdings-section")
				element[0].classList.toggle("expanded")

				if (element[0].classList.contains("expanded")) {
					this.arrowDirectionHoldings = "up"
				} else {
					this.arrowDirectionHoldings = "down"
				}
			},

			afterTradeSuccess() {
				this.$store.dispatch("setBalances")
				this.$store.dispatch("setGoldBalances")
				this.$store.dispatch("setHoldings")

				// refetch gold balances
				this.$store.dispatch("goldBalanceNew/fetchGoldBalance", {
					user_id: this.$store.state.userId,
				})
			},
		},
	}
</script>

<style scoped>
	.trade-ticket {
		/* 480px */
		width: 30rem;
		max-width: calc(100% - 2.5rem);
	}

	.modal {
		color: white;
		position: fixed;
		/*top: -233px;*/
		/*transform: translate(-50%, -50%);*/
	}

	.modal-overlay {
		position: fixed;
		background-color: rgb(0, 0, 0, 0.5);
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.modal-dialog {
		margin-top: 60px;
		margin-left: auto;
		margin-right: auto;
		/* max-width: fit-content; */
		max-width: 25em;
		min-width: min(400px, 100%);
	}

	.modal.show .modal-dialog {
		-webkit-transform: none;
		transform: none;
	}

	.modal-footer {
		display: block;
	}

	.modal-footer > * {
		margin-left: 0 !important;
	}

	.modal-content .modal-footer button {
		padding-left: 0;
		padding-right: 0;
	}

	.c-modal-header {
		background-color: #25273a;
		margin-bottom: 1px;
		padding-bottom: 1.5em;
	}

	.c-modal-body {
		background-color: #25273a;
		/*margin-bottom: 1px;*/
	}

	/* ================================================== */

	.balance-content {
		display: none;
	}

	.balance-section.expanded > .balance-content {
		display: block;
	}

	.holdings-section {
		color: white;
	}

	.holdings-content {
		display: none;
	}

	.holdings-section.expanded > .holdings-content {
		display: block;
	}

	.order-type {
		display: flex;
		justify-content: space-between;

		height: 2.75em;
		border-bottom: 1px solid var(--color-theme);
		gap: 8px;
	}

	.order-type > * {
		display: flex;
		justify-content: center;
		align-items: center;
		flex: 1 1 0;
	}

	.order-type > .active {
		background-color: var(--color-theme);
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
	}

	/* .active::after {
		content: '';
		display: block;
		position: absolute;
		background-color: var(--primary-color);
		bottom: calc(0px - var(--px-space-30));
		left: 0;
		right: 0;
		height: var(--px-space-02);
		border-radius: var(--px-space-02) var(--px-space-02) 0px 0px;
	} */

	.logobagi {
		height: 25.59px;
	}

	.c-balance {
		background-color: #2e3d61;
		display: inline-block;
		/*height: 34px;*/
		color: white;
		/* margin: auto; */
		width: 100%;
	}

	.c-pill {
		line-height: 0.6;
		width: 115px;
		height: 30px;
	}

	/*	.c-input-group-prepend {
		background-color: #1d1f2e;
		line-height: 38px;
	}*/
	.input-group-prepend {
		line-height: 38px;
		border-right: 1px solid #2b3553;
	}

	.c-prepend-button,
	.c-append-button {
		-webkit-touch-callout: none;
		/* iOS Safari */
		-webkit-user-select: none;
		/* Safari */
		-khtml-user-select: none;
		/* Konqueror HTML */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* Internet Explorer/Edge */
		user-select: none;
		/* Non-prefixed version, currently
																	supported by Chrome and Opera */
	}

	.c-prepend-button:hover,
	.c-append-button:hover {
		cursor: pointer;
	}

	.c-prepend-button:active,
	.c-append-button:active {
		border-color: #e14eca;
	}

	.input-group .form-control:not(:first-child):not(:last-child) {
		border-radius: 0;
		border-right: 0;
	}

	/*.c-input-group-append {
		border-bottom-left-radius: 0;
		border-top-left-radius: 0;
		line-height: 38px;
		border-bottom: 0;
		border-right: 0;
		border-top: 0;
		border-left: 0;
	}	*/
	.input-group-append {
		border-bottom-left-radius: 0;
		border-top-left-radius: 0;
		line-height: 38px;
		border-bottom: 0;
		border-right: 0;
		border-top: 0;
	}

	.form-control + .input-group-append .input-group-text {
		background-color: #1d1f2e;
		line-height: 16px;
	}

	.input-group-prepend .input-group-text,
	.input-group-prepend .input-group-text {
		background-color: #1d1f2e;
		line-height: 16px;
	}

	label {
		color: gold;
	}

	input {
		color: white;
	}

	.c-direction {
		width: 115px;
		height: 59px;
		color: white;
		padding: 10px 0px;
		font-family: Open Sans;
		font-weight: bold;
		font-size: 15px;
		line-height: 19px;
	}

	.c-direction:hover {
		cursor: pointer;
	}

	.buySellButtonActive {
		background-color: grey !important;
		color: rgb(255, 255, 255, 0.7);
	}

	.c-value {
		font-size: 18px;
	}

	.c-description {
		font-size: 11px;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		/* display: none; <- Crashes Chrome on hover */
		-webkit-appearance: none;
		margin: 0;
		/* <-- Apparently some margin are still there even though it's hidden */
	}

	input[type="number"] {
		-moz-appearance: textfield;
		/* Firefox */
	}

	.bootstrap-datetimepicker-widget {
		z-index: 999 !important;
	}

	.c-select {
		background: #25273a;
		padding-top: 1px;
		padding-bottom: 0px;
		padding-left: 5px;
		font-size: 12px;
	}

	input.c-disabled {
		color: rgb(255, 255, 255, 0.8);
	}

	.fa-sync-alt {
		position: absolute;
		color: white;
		position: absolute;
		/*top: 50%;	 position the top	edge of the element at the middle of the parent */
		left: 50%;
		/* position the left edge of the element at the middle of the parent */
		transform: translate(-50%, 0%);
		/* This is a shorthand of translateX(-50%) and translateY(-50%) */
		bottom: -20px;
		font-size: 12px;
		background-color: #2e3d61;
		/*padding: 5px 7px;*/
		/*border-radius: 50%;*/
	}

	.fa-sync-alt:active {
		color: lightgrey;
	}

	.fa-sync-alt:hover {
		cursor: pointer;
	}

	.c-input-group-text {
		font-size: 0.8em;
	}

	.close-market {
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 1;
		height: 180px;
		width: 100%;
		background-image: linear-gradient(
			transparent,
			rgba(0, 0, 0, 0.5),
			rgba(0, 0, 0, 1)
		);
		text-align: center;
	}

	.close-market-font::before {
		font-family: "Font Awesome 5 Free";
		font-weight: 400;
		content: "\f024";
		margin-right: 15px;
	}

	.close-market-font {
		position: relative;
		vertical-align: middle;
		color: #222;
		background-color: #777;
		display: inline-block;
		margin-top: 30px;
		padding: 10px 20px;
	}

	.close-market-exit {
		color: #f05a28 !important;
		cursor: pointer;
		position: absolute;
		top: -5px;
		right: -7px;
		background-color: #1a1e34;
		border-radius: 20px;
		width: 20px;
		height: 20px;
		margin: 0px;
		display: inline-block;
		font-weight: bold;
		line-height: 1em;
		transition: color 0.1s ease-in-out;
		border: 1px #777 solid;
	}

	.value-field {
		background-color: transparent;
	}

	.total-value {
		font-size: 16px;
	}

	.total-value.total-value-idr {
		line-height: 16px;
	}

	.c-input {
		margin: 0 2px;
		padding: 0 8px;
		/* border: 2px solid #171721; */
		background: transparent;
		height: 26.4px;
		border-radius: 4px;
		text-align: center;
		width: 93px;
		min-width: 93px;
	}

	.c-input:focus {
		border-color: gold;
		outline: none;
	}

	.button-counter {
		margin: 0;
		/*padding: 0;*/
		border: 0;
		height: 1.5rem;
		width: 1.5rem;
		background-color: var(--color-theme);
		color: white;
		font-weight: bold;
		border-radius: 4px;
	}

	.button-counter:hover {
		cursor: pointer;
	}

	.button-counter:active {
		background-color: gold;
		color: #25273a;
	}

	.button-counter:focus {
		outline: 0;
	}

	.c-select-box {
		position: relative;
		padding-right: 5px;
		border: 0;
		background-color: var(--color-grey12);
		height: 26.4px;
		color: gold;
		width: 150px;
		outline: 0;
		cursor: pointer;

		position: relative;
		overflow: hidden;
		z-index: 0;
	}

	.c-select-box:after {
		width: 0;
		height: 0;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-top: 6px solid gold;
		position: absolute;
		top: 40%;
		right: 8px;
		content: "";
		cursor: pointer;
		z-index: 0;
	}

	.c-select-box > span {
		position: absolute;
		color: white;
		font-size: 12px;
		height: 100%;
		padding: 2px 8px;
	}

	.c-select-box select {
		width: 150px;
		border: 0;
		position: relative;
		background: none;
		color: transparent;
		font-size: 12px;
		padding-left: 5px;
		outline: 0;
		cursor: pointer;
		z-index: 1;
	}

	/*.c-select {
		padding-right: 5px;
		border: 0;
		background-color: #25273A;
		height: 26.4px;
		color: gold;
		width: 137px;
		outline: 0;
		cursor: pointer;
	}*/

	.c-select > option {
		color: white;
		background-color: #171721;
	}

	.c-input.c-date-picker {
		position: relative;
		padding-left: 7px;
		padding-right: 6.5px;
		margin: 0;
		width: 180px;
		font-size: 12px;
		outline: 0;
		text-align: left;
		border: 0;
		background-color: #171721;
		cursor: text;
	}

	/*input[type="date"]::-webkit-calendar-picker-indicator {
		margin: 0px;
		filter: invert() hue-rotate(90deg);
	}*/

	input[type="date"]::-webkit-calendar-picker-indicator {
		position: relative;
		margin-left: 0;
		right: -3.5px;
		color: transparent;
		background: none;
		z-index: 1;
		outline: 0;
		cursor: pointer;
	}

	input[type="date"]:before {
		color: white;
		background: none;
		display: block;
		content: "\0023CD";
		position: absolute;
		top: 0px;
		right: 7px;
		color: gold;
	}

	.title-alert {
		font-size: 1.375rem;
		font-weight: 500;
		margin-bottom: 0.75rem;
	}

	.text-alert {
		margin-bottom: 2rem;
	}

	input[type="checkbox"] {
		height: 1.3rem;
		width: 1.3rem;
		margin-right: 1rem;
	}
</style>
